const NS = 'TabContainerBlock';
const CLS = 'tabContainerBlock';

export class TabContainerBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tabs = this.$element.find(`.${CLS}-tab-list`);
		this.$tabPanels = this.$element.find(`.${CLS}-tab-pane`);
		this.easeDuration = 300;
		const data = this.$element.data();
		const navs = window.eval(data.navs);
		this.state = {
			tabs: navs,
			threshold: data.threshold,
			isViewAll: false,
			activeKey: data.activeKey,

			numberOfTabs: this.$tabPanels.length
		};

		this.renderTabs();
		this.$tabLinks = this.$element.find(`.${CLS}-tab-link`);
		this.initializeEvents();
	}

	renderTabs() {
		const tabListTemplate = (state) => {
			const { numberOfTabs } = state;
			const navs = _.range(1, numberOfTabs + 1).map((value) => {
				return {
					id: `tab-${value}`,
					text: value,
					isActive: value == 1
				};
			});
			return navs.map(tabItemTemplate)
				.concat(tabItemSeeAll())
				.join('');
		};

		const tabItemTemplate = (tab) => {
			// Tab List HTML element
			return `<li class="${CLS}-tab-item nav-item">
				<a class="${CLS}-tab-link ${CLS}-tab-link--plain nav-link ${tab.isActive ? 'active' : ''}" data-key="${tab.id}" data-toggle="tab" data-target="#${tab.id}" href="javascript:void(0);">${tab.text}</a>
			</li>`;
		};

		const tabItemSeeAll = () => {
			// Tab List Item HTML element
			return `<li class="${CLS}-tab-item nav-item">
				<a class="${CLS}-tab-link ${CLS}-tab-link--seeAll nav-link" data-key='see-all' data-toggle="tab" role="tab" data-target="#see-all" role="tab" aria-controls="see-all" href="javascript:void(0);">See all</a>
			</li>`;
		};

		this.$tabs.empty();
		this.$tabs.append(tabListTemplate(this.state));
	}

	initializeEvents() {
		this.$element.find(`.${CLS}-tab-link--seeAll`).on('click', () => {
			this.$element.addClass(`${CLS}--seeAll`);
		});

		this.$element.find(`.${CLS}-tab-link--plain`).on('click', (event) => {
			this.$element.removeClass(`${CLS}--seeAll`);
		});

		this.$element.find(`.tabItemBlock-btn`).on('click', () => {
			let index = this.$element.find(`.${CLS}-tab-pane.active`).index();

			if(index + 1 < this.$tabPanels.length) {
				let $nextLink = this.$tabLinks.eq(index + 1);
				$nextLink.tab('show');
			}
		});

		this.$element.on('shown.bs.tab', '[data-toggle="tab"]', (e) => {
			let scrollTopPos = this.$element.offset().top;
			let siteHeaderWidget = $(document).find('.siteHeaderWidget');

			if(siteHeaderWidget.length > 0) {
				scrollTopPos = Number(scrollTopPos) - Number(siteHeaderWidget.height());
			}

			$('html, body').animate({
				scrollTop: scrollTopPos
			}, this.easeDuration);
		});
	}
}


